import Vue from 'vue'

export default {
  inserted: function (el, binding, vnode) {
    Vue.nextTick(function() {
      el.focus()
    })
  }
}
